import React from "react";
// import menuIcon from "../../assets/images/menuIcon.svg";
import logo from "../../assets/images/logosvg.svg";
import menuIconlarge from "../../assets/images/offcanvas.svg";
// import { MdPerson } from "react-icons/md";
import { HiOutlineUser, HiLogout } from "react-icons/hi";

import { NavLink, Link } from "react-router-dom";
import {
  TiSocialTwitter,
  TiSocialFacebook,
  TiSocialInstagram,
} from "react-icons/ti";
import { PiTiktokLogoDuotone } from "react-icons/pi";
import { FaSnapchatGhost } from "react-icons/fa";
const Offcanvas = ({ user, logout, isOpen, handleToggle }) => {
  return (
    <div className="flex relative justify-start items-center z-[999999]   ">
      {/* Button to toggle the offcanvas */}

      {/* Offcanvas panel */}
      {isOpen && (
        <>
          {/* Overlay */}
          <div
            className="fixed  top-0 left-0 right-0 bottom-0 bg-black opacity-30  z-10"
            onClick={handleToggle}
          ></div>
          <div className="fixed offcanvas-style top-0 right-0 bottom-0 bg-white w-[254px]   z-50  shadow-lg">
            <div className="relative">
              <div className="flex h-[90px] bg-[#fff]   justify-center items-center ">
                <button
                  className=" absolute right-[26px] top-[40px] ml-[40px] "
                  onClick={handleToggle}
                >
                  <img
                    className="w-[50px] h-[50px]"
                    src={menuIconlarge}
                    alt=""
                  />
                </button>
                <img
                  className="absolute right-[83px] top-[40px] ml-[40px] "
                  src={logo}
                  alt=""
                />
              </div>
              {/* Content */}
              <div className=" w-full mb-[31px]  flex justify-center items-center ">
                {user ? (
                  <div className="bg-[#FAFCFE] font-bold  w-full  ">
                    <p className=" w-full flex justify-center items-center text-[#263238] my-4 ">
                      {user.name}
                    </p>

                    <p className=" w-full text-[#263238] my-4 flex justify-center items-center">
                      {user.phone}
                    </p>

                    <Link
                      to="/account"
                      className="w-[184px] mx-auto h-[32px] text-white text-[.9rem] font-bold login-mobile flex justify-center items-center"
                      onClick={handleToggle}
                    >
                      <HiOutlineUser className="text-white ml-1 "></HiOutlineUser>
                      إدارة الحساب
                    </Link>
                    {/* <Link
                      to="/"
                      className="w-[184px] h-[32px] mx-auto text-white text-[.9rem] font-bold  signUp-mobile
                       flex justify-center items-center"
                      onClick={handleToggle}
                    >
                      <HiCog className="ml-2" />
                      الاعدادات
                    </Link> */}
                  </div>
                ) : (
                  ""
                )}
                {/* <div>
                  <Link
                    to="/login"
                    className="w-[184px] h-[32px] text-white text-[.9rem] font-bold login-mobile flex justify-center items-center"
                  >
                    <MdPerson className="text-white ml-1 "></MdPerson> تسجيل
                    دخول
                  </Link>
                  <Link
                    to="/register"
                    className="w-[184px] h-[32px] text-white text-[.9rem] font-bold  signUp-mobile flex justify-center items-center"
                  >
                    تسجيل
                  </Link>
                </div> */}
              </div>
              <ul
                style={{ borderBottom: "1px solid #D2EAEC" }}
                className="w-full flex justify-center items-center  "
              >
                <div className="text-center menu-mob-offcanvas">
                  <li onClick={handleToggle}>
                    <NavLink to="/">الرئيسية</NavLink>
                  </li>
                  <li onClick={handleToggle}>
                    <NavLink to="/couponsoffers">العروض و الكوبونات</NavLink>
                  </li>
                  <li onClick={handleToggle}>
                    <NavLink to="/MedicalNetwork">الشبكة الطبية</NavLink>
                  </li>
                  <li onClick={handleToggle}>
                    <NavLink to="/about">من نحن</NavLink>
                  </li>
                  <li onClick={handleToggle}>
                    <NavLink to="/contact">تواصل معنا</NavLink>
                  </li>
                  <li onClick={handleToggle}>
                    <NavLink to="/membership">تحقق من العضوية</NavLink>
                  </li>
                </div>
              </ul>
              {user ? (
                <div className="flex justify-center items-center">
                  <button
                    className="mt-4 flex justify-center items-center font-semibold text-[#47BECC]"
                    onClick={logout}
                  >
                    <HiLogout className="ml-2" />
                    تسجيل الخروج
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="social-offcanvas flex justify-center w-full items-center">
              <div className="  p-2 rounded-full text-white">
                <TiSocialFacebook />
              </div>
              <div className="  p-2 rounded-full text-white">
                <TiSocialTwitter />
              </div>
              <div className="  p-2 rounded-full text-white">
                <FaSnapchatGhost />
              </div>
              <div className="  p-2 rounded-full text-white">
                <TiSocialInstagram />
              </div>
              <div className="  p-2 rounded-full text-white">
                <PiTiktokLogoDuotone />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Offcanvas;
